var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSuccess24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.6244795,0.00708627409 23.9929137,5.37552045 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.71428571 C6.31935686,1.71428571 1.71428571,6.31935686 1.71428571,12 C1.71428571,17.6806431 6.31935686,22.2857143 12,22.2857143 C17.6780974,22.279573 22.279573,17.6780974 22.2857143,12 C22.2857143,6.31935686 17.6806431,1.71428571 12,1.71428571 Z M15.8057143,8.08885714 C16.1285243,7.75462725 16.6065573,7.6205838 17.0560808,7.73824651 C17.5056044,7.85590922 17.8566622,8.20696703 17.9743249,8.65649058 C18.0919876,9.10601414 17.9579442,9.58404711 17.6237143,9.90685714 L17.6237143,9.90685714 L10.7665714,16.764 C10.2668453,17.263598 9.45759519,17.2662777 8.95457143,16.77 L8.95457143,16.77 L5.526,13.3885714 C5.02042276,12.8898583 5.0148583,12.0757201 5.51357143,11.5701429 C6.01228456,11.0645656 6.82642276,11.0590012 7.332,11.5577143 L7.332,11.5577143 L9.85114286,14.0434286 L15.8057143,8.08971429 Z",
    id: "Combined-Shape",
    fill: "#177D3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess24);
export default __webpack_public_path__ + "static/media/messageSuccess24.2e1c8bbdc6d48bdf63780282a15631af.svg";
export { ForwardRef as ReactComponent };